(function (window, document) {
  const forms = document.querySelectorAll('.consumer-rx-form');
  // If no forms are found, do nothing.
  if (!forms.length) return;

  // For each form, give it a unique ID and fire instantiation event for it.
  forms.forEach((form, index) => {
    form.id = `consumer-rx-form-${index + 1}`;
    window.componentEvents.emitEvent('consumer-rx-form-instantiate', [form]);
  });
})(window, document);
